import React, { memo } from 'react';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import costServiceConfIcon from 'assets/images/costServiceConfIcon.svg';

/**
 * GameConfButton Component
 * ゲーム設定画面遷移ボタン
 * @author takuya.tomisato
 *
 * @param props
 * @returns {*}
 * @constructor
 */

// 型定義
type Props = {
  fullWidth?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

// makeStylesでstyleを定義
const useStyles = makeStyles()((theme) => ({
  button: {
    position: 'relative',
    color: theme.palette.common.black,
    borderRadius: '8px',
    background: '#EBEBEB',
    height: '276px',
    width: '264px',
    fontSize: '27px',
    textAlign: 'center',
    lineHeight: '28px',
    marginLeft: '28px',
    marginTop: '20px',
    boxShadow: '5px 5px 3px 0px rgba(0, 0, 0, 0.2)',
    '&:hover': {
      background: '#EBEBEB',
      boxShadow: '5px 5px 3px 0px rgba(0, 0, 0, 0.2)',
    },
    '& img': {
      position: 'relative',
      width: '60px',
      height: '60px',
    },
  },
  title: {
    position: 'relative',
    transform: 'translateY(-20%)',
    // width: '100%',
  },
  frame: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  detailSl: {
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: '#6A6A6A',
    borderRadius: '4px',
    fontSize: '19px',
    marginBottom: '4px',
    marginbottom: '4px',
    width: '114px',
    height: '36px',
    lineHeight: '36px',
    float: 'left',
    verticalAlign: 'middle',
  },
  detailSr: {
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: '#6A6A6A',
    borderRadius: '4px',
    fontSize: '19px',
    margin: '0 0 0 4px',
    marginBottom: '4px',
    width: '114px',
    height: '36px',
    lineHeight: '36px',
    float: 'left',
    verticalAlign: 'middle',
  },
  detailSrlast: {
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: '#6A6A6A',
    borderRadius: '4px',
    margin: '0 0 0 4px',
    width: '114px',
    height: '36px',

    float: 'left',
  },
  p1: {
    height: '16px',
    lineHeight: '16px',
    fontSize: '16px',
  },
  p2: {
    height: '16px',
    lineHeight: '16px',
    fontSize: '16px',
  },
}));

// コンポーネント定義
const CostServiceConfButton: React.FC<React.PropsWithChildren<Props>> = (props) => {
  // makeStyleで定義したstyleを取得
  const { classes } = useStyles();

  // イベント定義

  // propsのプロパティ情報を取得
  const { fullWidth, onClick } = props;

  return (
    <Button variant="contained" fullWidth={fullWidth} className={classes.button} onClick={onClick}>
      <div className={classes.frame}>
        <div className={classes.title}>
          <b>料金・サービス</b>
        </div>
        <img src={costServiceConfIcon} alt="料金サービス" />
        <div>
          <div className={classes.detailSl}>料金設定</div>
          <div className={classes.detailSr}>景品原価</div>
        </div>
        <div>
          <div className={classes.detailSl}>目標原価率</div>
          <div className={classes.detailSr}>とり放題</div>
        </div>
        <div>
          <div className={classes.detailSl}>両替時間</div>
          <div className={classes.detailSrlast}>
            <div className={classes.p1}>連続プレイ</div>
            <div className={classes.p2}>みなし時間</div>
          </div>
        </div>
        <br />
      </div>
    </Button>
  );

  return <></>;
};

// propsの初期値。未指定時に使用する。
CostServiceConfButton.defaultProps = {
  fullWidth: false,
};

// レンダーが前回と変わらない場合前回のレンダーを再利用
export default memo(CostServiceConfButton);
